// extracted by mini-css-extract-plugin
export default {"link":"Legal_link__6+rHb"};